// The generated API client serializes a Date via toISOString(), so a local-midnight value crosses
// the wire as the previous day east of UTC. UTC midnight is what preserves the calendar day.
export function toCalendarDay(date: Date): Date {
	return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}
